export const boats = {
    regionName: 'Boats',
    regionValue: 'Boats',
    regionId: 15979,
    url: '/boat-holidays',
    regions: [
        {
            regionName: 'The Broads',
            regionValue: 'The Broads',
            regionId: 21645,
            url: '/the-broads',
            regions: [
                {
                    regionName: 'All of The Broads',
                    regionValue: 'All of The Broads',
                    regionId: 21645,
                    url: '/the-broads',
                },
                {
                    regionName: 'Acle',
                    regionValue: 'Acle',
                    regionId: 21648,
                    url: '/acle',
                },
                {
                    regionName: 'Brundall',
                    regionValue: 'Brundall',
                    regionId: 21649,
                    url: '/brundall',
                },
                {
                    regionName: 'Burgh St Peter',
                    regionValue: 'Burgh St Peter',
                    regionId: 20001,
                    url: '/burgh-st-peter',
                },
                {
                    regionName: 'Hickling & Stalham',
                    regionValue: 'Hickling & Stalham',
                    regionId: 21651,
                    url: '/hickling-stalham',
                },
                {
                    regionName: 'Houseboats',
                    regionValue: 'Houseboats',
                    regionId: 21652,
                    url: '/houseboats',
                },
                {
                    regionName: 'Reedham',
                    regionValue: 'Reedham',
                    regionId: 21650,
                    url: '/reedham',
                },
                {
                    regionName: 'Wroxham & Horning',
                    regionValue: 'Wroxham & Horning',
                    regionId: 21647,
                    url: '/wroxham-horning',
                },
            ],
        },
        {
            regionName: 'Canals and Rivers',
            regionValue: 'Canals and Rivers',
            regionId: 21646,
            url: '/canals-and-rivers',
            regions: [
                {
                    regionName: 'All Canals and Rivers',
                    regionValue: 'All Canals and Rivers',
                    regionId: 21646,
                    url: '/canals-and-rivers',
                },
                {
                    regionName: 'Cambridgeshire Waterways',
                    regionValue: 'Cambridgeshire Waterways',
                    regionId: 21653,
                    url: '/cambridgeshire-waterways',
                },
                {
                    regionName: 'Cheshire Ring & Llangollen Canal',
                    regionValue: 'Cheshire Ring & Llangollen Canal',
                    regionId: 21659,
                    url: '/cheshire-ring-llangollen-canal',
                },
                {
                    regionName: 'Heart of England Canals',
                    regionValue: 'Heart of England Canals',
                    regionId: 21657,
                    url: '/heart-of-england-canals',
                },
                {
                    regionName: 'Kennet & Avon Canal',
                    regionValue: 'Kennet & Avon Canal',
                    regionId: 21655,
                    url: '/kennet-avon-canal',
                },
                {
                    regionName: 'Leeds & Liverpool Canal',
                    regionValue: 'Leeds & Liverpool Canal',
                    regionId: 23671,
                    url: '/leeds-liverpool-canal',
                },
                {
                    regionName: 'Monmouth & Brecon Canal',
                    regionValue: 'Monmouth & Brecon Canal',
                    regionId: 21660,
                    url: '/monmouth-brecon-canal',
                },
                {
                    regionName: 'Oxford & Midlands Canal',
                    regionValue: 'Oxford & Midlands Canal',
                    regionId: 21656,
                    url: '/oxford-midlands-canal',
                },
                {
                    regionName: 'River Thames',
                    regionValue: 'River Thames',
                    regionId: 21654,
                    url: '/river-thames-wey',
                },
                {
                    regionName: 'Scotland Lochs & Canals',
                    regionValue: 'Scotland Lochs & Canals',
                    regionId: 21661,
                    url: '/scotland-lochs-canals',
                },
            ],
        },
    ],
};
export default [
    {
        regionName: 'All of UK',
        regionValue: 'All of UK',
        regionId: null,
        url: '/all-regions',
    },
    {
        regionName: 'England',
        regionValue: 'England',
        regionId: 21667,
        url: '/england',
        regions: [
            {
                regionName: 'All of England',
                regionValue: 'England',
                regionId: 21667,
                url: '/england',
            },
            {
                regionName: 'South West England',
                regionValue: 'South West England',
                regionId: 21996,
                url: '/england',
                regions: [
                    {
                        regionName: 'All of South West England',
                        regionValue: 'South West England',
                        regionId: 21996,
                        url: '/england',
                    },
                    {
                        regionName: 'Cornwall',
                        regionValue: 'Cornwall',
                        regionId: 22070,
                        url: '/england/cornwall',
                    },
                    {
                        regionName: 'Devon',
                        regionValue: 'Devon',
                        regionId: 21997,
                        url: '/england/devon',
                    },
                    {
                        regionName: 'Dorset',
                        regionValue: 'Dorset',
                        regionId: 22035,
                        url: '/england/dorset',
                    },
                    {
                        regionName: 'Somerset',
                        regionValue: 'Somerset',
                        regionId: 22052,
                        url: '/england/somerset',
                    },
                ],
            },
            {
                regionName: 'Southern England',
                regionValue: 'Southern England',
                regionId: 21668,
                url: '/england',
                regions: [
                    {
                        regionName: 'All of Southern England',
                        regionValue: 'Southern England',
                        regionId: 21668,
                        url: '/england',
                    },
                    {
                        regionName: 'Berkshire',
                        regionValue: 'Berkshire',
                        regionId: 21696,
                        url: '/england/berkshire',
                    },
                    {
                        regionName: 'Greater London',
                        regionValue: 'Greater London',
                        regionId: 21727,
                        url: '/england/greater-london',
                    },
                    {
                        regionName: 'Hampshire',
                        regionValue: 'Hampshire',
                        regionId: 21711,
                        url: '/england/hampshire',
                    },
                    {
                        regionName: 'Isle of Wight',
                        regionValue: 'Isle of Wight',
                        regionId: 21730,
                        url: '/england/isle-of-wight',
                    },
                    {
                        regionName: 'Kent',
                        regionValue: 'Kent',
                        regionId: 21669,
                        url: '/england/kent',
                    },
                    {
                        regionName: 'Surrey',
                        regionValue: 'Surrey',
                        regionId: 21693,
                        url: '/england/surrey',
                    },
                    {
                        regionName: 'Sussex',
                        regionValue: 'Sussex',
                        regionId: 21699,
                        url: '/england/sussex',
                    },
                    {
                        regionName: 'Wiltshire',
                        regionValue: 'Wiltshire',
                        regionId: 21679,
                        url: '/england/wiltshire',
                    },
                ],
            },
            {
                regionName: 'Central England',
                regionValue: 'Central England',
                regionId: 21808,
                url: '/england',
                regions: [
                    {
                        regionName: 'All of Central England',
                        regionValue: 'Central England',
                        regionId: 21808,
                        url: '/england',
                    },
                    {
                        regionName: 'Bedfordshire',
                        regionValue: 'Bedfordshire',
                        regionId: 21895,
                        url: '/england/bedfordshire',
                    },
                    {
                        regionName: 'Buckinghamshire',
                        regionValue: 'Buckinghamshire',
                        regionId: 21889,
                        url: '/england/buckinghamshire',
                    },
                    {
                        regionName: 'Derbyshire',
                        regionValue: 'Derbyshire',
                        regionId: 21863,
                        url: '/england/derbyshire',
                    },
                    {
                        regionName: 'Gloucestershire',
                        regionValue: 'Gloucestershire',
                        regionId: 21843,
                        url: '/england/gloucestershire',
                    },
                    {
                        regionName: 'Herefordshire',
                        regionValue: 'Herefordshire',
                        regionId: 21898,
                        url: '/england/herefordshire',
                    },
                    {
                        regionName: 'Hertfordshire',
                        regionValue: 'Hertfordshire',
                        regionId: 21814,
                        url: '/england/hertfordshire',
                    },
                    {
                        regionName: 'Leicestershire',
                        regionValue: 'Leicestershire',
                        regionId: 21892,
                        url: '/england/leicestershire',
                    },
                    {
                        regionName: 'Lincolnshire',
                        regionValue: 'Lincolnshire',
                        regionId: 21817,
                        url: '/england/lincolnshire',
                    },
                    {
                        regionName: 'Northamptonshire',
                        regionValue: 'Northamptonshire',
                        regionId: 21877,
                        url: '/england/northamptonshire',
                    },
                    {
                        regionName: 'Nottinghamshire',
                        regionValue: 'Nottinghamshire',
                        regionId: 21835,
                        url: '/england/nottinghamshire',
                    },
                    {
                        regionName: 'Oxfordshire',
                        regionValue: 'Oxfordshire',
                        regionId: 21809,
                        url: '/england/oxfordshire',
                    },
                    {
                        regionName: 'Rutland',
                        regionValue: 'Rutland',
                        regionId: 21832,
                        url: '/england/rutland',
                    },
                    {
                        regionName: 'Shropshire',
                        regionValue: 'Shropshire',
                        regionId: 21880,
                        url: '/england/shropshire',
                    },
                    {
                        regionName: 'Staffordshire',
                        regionValue: 'Staffordshire',
                        regionId: 21838,
                        url: '/england/staffordshire',
                    },
                    {
                        regionName: 'Warwickshire',
                        regionValue: 'Warwickshire',
                        regionId: 21827,
                        url: '/england/warwickshire',
                    },
                    {
                        regionName: 'Worcestershire',
                        regionValue: 'Worcestershire',
                        regionId: 21857,
                        url: '/england/worcestershire',
                    },
                ],
            },
            {
                regionName: 'East Anglia',
                regionValue: 'East Anglia',
                regionId: 21906,
                url: '/england',
                regions: [
                    {
                        regionName: 'All of East Anglia',
                        regionValue: 'East Anglia',
                        regionId: 21906,
                        url: '/england',
                    },
                    {
                        regionName: 'Cambridgeshire',
                        regionValue: 'Cambridgeshire',
                        regionId: 21907,
                        url: '/england/cambridgeshire',
                    },
                    {
                        regionName: 'Essex',
                        regionValue: 'Essex',
                        regionId: 21948,
                        url: '/england/essex',
                    },
                    {
                        regionName: 'Norfolk',
                        regionValue: 'Norfolk',
                        regionId: 21911,
                        url: '/england/norfolk',
                    },
                    {
                        regionName: 'Suffolk',
                        regionValue: 'Suffolk',
                        regionId: 21933,
                        url: '/england/suffolk',
                    },
                ],
            },
            {
                regionName: 'North West England',
                regionValue: 'North West England',
                regionId: 21952,
                url: '/england',
                regions: [
                    {
                        regionName: 'All of North West England',
                        regionValue: 'North West England',
                        regionId: 21952,
                        url: '/england',
                    },
                    {
                        regionName: 'Cheshire',
                        regionValue: 'Cheshire',
                        regionId: 21953,
                        url: '/england/cheshire',
                    },
                    {
                        regionName: 'Cumbria',
                        regionValue: 'Cumbria',
                        regionId: 21966,
                        url: '/england/cumbria',
                    },
                    {
                        regionName: 'Lancashire',
                        regionValue: 'Lancashire',
                        regionId: 21958,
                        url: '/england/lancashire',
                    },
                ],
            },
            {
                regionName: 'North East England',
                regionValue: 'North East England',
                regionId: 21740,
                url: '/england',
                regions: [
                    {
                        regionName: 'All of North East England',
                        regionValue: 'North East England',
                        regionId: 21740,
                        url: '/england',
                    },
                    {
                        regionName: 'County Durham',
                        regionValue: 'County Durham',
                        regionId: 21757,
                        url: '/england/county-durham',
                    },
                    {
                        regionName: 'Northumberland',
                        regionValue: 'Northumberland',
                        regionId: 21741,
                        url: '/england/northumberland',
                    },
                ],
            },
            {
                regionName: 'Yorkshire',
                regionValue: 'Yorkshire',
                regionId: 21764,
                url: '/england/yorkshire',
                regions: [
                    {
                        regionName: 'Yorkshire',
                        regionValue: 'Yorkshire',
                        regionId: 21764,
                        url: '/england/yorkshire',
                    },
                ],
            },
        ],
        popular: {
            title: 'Popular in England',
            locations: [
                {
                    regionName: 'Blackdown Hills',
                    regionValue: 'Blackdown Hills',
                    regionId: 10135,
                    url: '/england/blackdown-hills',
                },
                {
                    regionName: 'Constable Country',
                    regionValue: 'Constable Country',
                    regionId: 10096,
                    url: '/england/constable-country',
                },
                {
                    regionName: 'Cotswolds',
                    regionValue: 'Cotswolds',
                    regionId: 9125,
                    url: '/england/cotswolds',
                },
                {
                    regionName: 'Cranborne Chase & West Wiltshire Downs',
                    regionValue: 'Cranborne Chase & West Wiltshire Downs',
                    regionId: 10274,
                    url: '/england/cranborne-chase-and-west-wiltshire-downs',
                },
                {
                    regionName: 'Dartmoor',
                    regionValue: 'Dartmoor',
                    regionId: 9126,
                    url: '/england/dartmoor',
                },
                {
                    regionName: 'Exmoor',
                    regionValue: 'Exmoor',
                    regionId: 9127,
                    url: '/england/dartmoor',
                },
                {
                    regionName: 'Forest of Bowland',
                    regionValue: 'Forest of Bowland',
                    regionId: 10275,
                    url: '/england/forest-of-bowland',
                },
                {
                    regionName: 'Forest of Dean',
                    regionValue: 'Forest of Dean',
                    regionId: 9277,
                    url: '/england/forest-of-dean',
                },
                {
                    regionName: 'High Weald',
                    regionValue: 'High Weald',
                    regionId: 10136,
                    url: '/england/high-weald',
                },
                {
                    regionName: 'Howardian Hills',
                    regionValue: 'Howardian Hills',
                    regionId: 10276,
                    url: '/england/howardian-hills',
                },
                {
                    regionName: 'Kent Downs',
                    regionValue: 'Kent Downs',
                    regionId: 10134,
                    url: '/england/kent-downs',
                },
                {
                    regionName: 'Lake District',
                    regionValue: 'Lake District',
                    regionId: 9128,
                    url: '/england/lake-district',
                },
                {
                    regionName: 'Lincolnshire Wolds',
                    regionValue: 'Lincolnshire Wolds',
                    regionId: 10128,
                    url: '/england/lincolnshire-wolds',
                },
                {
                    regionName: 'Malvern Hills',
                    regionValue: 'Malvern Hills',
                    regionId: 10132,
                    url: '/england/malvern-hills',
                },
                {
                    regionName: 'Mendip Hills',
                    regionValue: 'Mendip Hills',
                    regionId: 10277,
                    url: '/england/mendip-hills',
                },
                {
                    regionName: 'New Forest',
                    regionValue: 'New Forest',
                    regionId: 9130,
                    url: '/england/new-forest',
                },
                {
                    regionName: 'Nidderdale',
                    regionValue: 'Nidderdale',
                    regionId: 10278,
                    url: '/england/nidderdale',
                },
                {
                    regionName: 'Norfolk Broads',
                    regionValue: 'Norfolk Broads',
                    regionId: 9131,
                    url: '/england/norfolk-broads',
                },
                {
                    regionName: 'North Devon Coast',
                    regionValue: 'North Devon Coast',
                    regionId: 10133,
                    url: '/england/north-devon-coast',
                },
                {
                    regionName: 'Norfolk Coast',
                    regionValue: 'Norfolk Coast',
                    regionId: 10131,
                    url: '/england/norfolk-coast',
                },
                {
                    regionName: 'North Pennines',
                    regionValue: 'North Pennines',
                    regionId: 9782,
                    url: '/england/north-pennines',
                },
                {
                    regionName: 'North Wessex Downs',
                    regionValue: 'North Wessex Downs',
                    regionId: 10279,
                    url: '/england/north-wessex-downs',
                },
                {
                    regionName: 'Northumberland Coast',
                    regionValue: 'Northumberland Coast',
                    regionId: 10129,
                    url: '/england/northumberland-coast',
                },
                {
                    regionName: 'Peak District',
                    regionValue: 'Peak District',
                    regionId: 9133,
                    url: '/england/peak-district',
                },
                {
                    regionName: 'Shakespeare Country',
                    regionValue: 'Shakespeare Country',
                    regionId: 9318,
                    url: '/england/shakespeare-country',
                },
                {
                    regionName: 'Shropshire Hills',
                    regionValue: 'Shropshire Hills',
                    regionId: 10137,
                    url: '/england/shropshire-hills',
                },
                {
                    regionName: 'South Downs',
                    regionValue: 'South Downs',
                    regionId: 9136,
                    url: '/england/south-downs',
                },
                {
                    regionName: 'Suffolk Coast and Heaths',
                    regionValue: 'Suffolk Coast and Heaths',
                    regionId: 10130,
                    url: '/england/suffolk-coast-and-heaths',
                },
                {
                    regionName: 'Wye Valley',
                    regionValue: 'Wye Valley',
                    regionId: 9278,
                    url: '/england/wye-valley',
                },
                {
                    regionName: 'Yorkshire Dales',
                    regionValue: 'Yorkshire Dales',
                    regionId: 9137,
                    url: '/england/yorkshire-dales',
                },
                {
                    regionName: 'Yorkshire Moors',
                    regionValue: 'Yorkshire Moors',
                    regionId: 9138,
                    url: '/england/yorkshire-moors',
                },
            ],
        },
    },
    {
        regionName: 'Scotland',
        regionValue: 'Scotland',
        regionId: 1429,
        url: '/scotland',
        regions: [
            {
                regionName: 'All of Scotland',
                regionValue: 'Scotland',
                regionId: 1429,
                url: '/scotland',
            },
            {
                regionName: 'Southern Scotland',
                regionValue: 'Southern Scotland',
                regionId: 22370,
                url: '/scotland',
                regions: [
                    {
                        regionName: 'All of Southern Scotland',
                        regionValue: 'Southern Scotland',
                        regionId: 22370,
                        url: '/scotland',
                    },
                    {
                        regionName: 'Ayrshire',
                        regionValue: 'Ayrshire',
                        regionId: 22374,
                        url: '/scotland/ayrshire',
                    },
                    {
                        regionName: 'Dumfries and Galloway',
                        regionValue: 'Dumfries and Galloway',
                        regionId: 22384,
                        url: '/scotland/dumfries-and-galloway',
                    },
                    {
                        regionName: 'Edinburgh and the Lothians',
                        regionValue: 'Edinburgh and the Lothians',
                        regionId: 22371,
                        url: '/scotland/edinburgh-and-the-lothians',
                    },
                    {
                        regionName: 'Glasgow and the Clyde Valley',
                        regionValue: 'Glasgow and the Clyde Valley',
                        regionId: 22380,
                        url: '/scotland/glasgow-and-the-clyde-valley',
                    },
                    {
                        regionName: 'Isle of Arran',
                        regionValue: 'Isle of Arran',
                        regionId: 22401,
                        url: '/scotland/isle-of-arran',
                    },
                    {
                        regionName: 'Isle Of Cumbrae',
                        regionValue: 'Isle Of Cumbrae',
                        regionId: 23519,
                        url: '/scotland/isle-of-cumbrae',
                    },
                    {
                        regionName: 'The Scottish Borders',
                        regionValue: 'The Scottish Borders',
                        regionId: 22394,
                        url: '/scotland/the-scottish-borders',
                    },
                ],
            },
            {
                regionName: 'Central Scotland',
                regionValue: 'Central Scotland',
                regionId: 22334,
                url: '/scotland',
                regions: [
                    {
                        regionName: 'All of Central Scotland',
                        regionValue: 'Central Scotland',
                        regionId: 22334,
                        url: '/scotland',
                    },
                    {
                        regionName: 'Angus',
                        regionValue: 'Angus',
                        regionId: 22335,
                        url: '/scotland/angus',
                    },
                    {
                        regionName: 'Argyll and Bute',
                        regionValue: 'Argyll and Bute',
                        regionId: 22340,
                        url: '/scotland/argyll-and-bute',
                    },
                    {
                        regionName: 'Fife',
                        regionValue: 'Fife',
                        regionId: 22360,
                        url: '/scotland/fife',
                    },
                    {
                        regionName: 'Isle of Islay',
                        regionValue: 'Isle of Islay',
                        regionId: 23657,
                        url: '/scotland/isle-of-islay',
                    },
                    {
                        regionName: 'Isle of Mull',
                        regionValue: 'Isle of Mull',
                        regionId: 22352,
                        url: '/scotland/isle-of-mull',
                    },
                    {
                        regionName: 'Isle of Tiree',
                        regionValue: 'Isle of Tiree',
                        regionId: 23654,
                        url: '/scotland/isle-of-tiree',
                    },
                    {
                        regionName: 'Perthshire',
                        regionValue: 'Perthshire',
                        regionId: 22365,
                        url: '/scotland/perthshire',
                    },
                    {
                        regionName: 'Stirlingshire',
                        regionValue: 'Stirlingshire',
                        regionId: 22356,
                        url: '/scotland/stirlingshire',
                    },
                ],
            },
            {
                regionName: 'Northern Scotland',
                regionValue: 'Northern Scotland',
                regionId: 22293,
                url: '/scotland',
                regions: [
                    {
                        regionName: 'All of Northern Scotland',
                        regionValue: 'Northern Scotland',
                        regionId: 22293,
                        url: '/scotland',
                    },
                    {
                        regionName: 'Aberdeenshire',
                        regionValue: 'Aberdeenshire',
                        regionId: 22329,
                        url: '/scotland/aberdeenshire',
                    },
                    {
                        regionName: 'Highlands',
                        regionValue: 'Highlands',
                        regionId: 22301,
                        url: '/scotland/highlands',
                    },
                    {
                        regionName: 'Isle of Skye',
                        regionValue: 'Isle of Skye',
                        regionId: 22294,
                        url: '/scotland/isle-of-skye',
                    },
                    {
                        regionName: 'Orkney Islands',
                        regionValue: 'Orkney Islands',
                        regionId: 22298,
                        url: '/scotland/orkney-islands',
                    },
                    {
                        regionName: 'Outer Hebrides',
                        regionValue: 'Outer Hebrides',
                        regionId: 22326,
                        url: '/scotland/outer-hebrides',
                    },
                ],
            },
        ],
        popular: {
            title: 'Popular in Scotland',
            locations: [
                {
                    regionName: 'Cairngorms',
                    regionValue: 'Cairngorms',
                    regionId: 9124,
                    url: '/scotland/cairngorms',
                },
                {
                    regionName: 'Loch Lomond and the Trossachs',
                    regionValue: 'Loch Lomond and the Trossachs',
                    regionId: 9129,
                    url: '/scotland/loch-lomond-and-the-trossachs',
                },
            ],
        },
    },
    {
        regionName: 'Wales',
        regionValue: 'Wales',
        regionId: 22217,
        url: '/wales',
        regions: [
            {
                regionName: 'All of Wales',
                regionValue: 'Wales',
                regionId: 22217,
                url: '/wales',
            },
            {
                regionName: 'South Wales',
                regionValue: 'South Wales',
                regionId: 22234,
                url: '/wales',
                regions: [
                    {
                        regionName: 'All of South Wales',
                        regionValue: 'South Wales',
                        regionId: 22234,
                        url: '/wales',
                    },
                    {
                        regionName: 'Carmarthenshire',
                        regionValue: 'Carmarthenshire',
                        regionId: 22239,
                        url: '/wales/carmarthenshire',
                    },
                    {
                        regionName: 'Glamorgan',
                        regionValue: 'Glamorgan',
                        regionId: 22247,
                        url: '/wales/glamorgan',
                    },
                    {
                        regionName: 'Monmouthshire',
                        regionValue: 'Monmouthshire',
                        regionId: 22235,
                        url: '/wales/monmouthshire',
                    },
                    {
                        regionName: 'Pembrokeshire',
                        regionValue: 'Pembrokeshire',
                        regionId: 22251,
                        url: '/wales/pembrokeshire',
                    },
                ],
            },
            {
                regionName: 'Mid Wales',
                regionValue: 'Mid Wales',
                regionId: 22218,
                url: '/wales',
                regions: [
                    {
                        regionName: 'All of Mid Wales',
                        regionValue: 'Mid Wales',
                        regionId: 22218,
                        url: '/wales',
                    },
                    {
                        regionName: 'Cardigan/Ceredigion',
                        regionValue: 'Cardigan/Ceredigion',
                        regionId: 22226,
                        url: '/wales/cardiganceredigion',
                    },
                    {
                        regionName: 'Powys',
                        regionValue: 'Powys',
                        regionId: 22219,
                        url: '/wales/cardiganceredigion',
                    },
                ],
            },
            {
                regionName: 'North Wales',
                regionValue: 'North Wales',
                regionId: 22258,
                url: '/wales',
                regions: [
                    {
                        regionName: 'All of North Wales',
                        regionValue: 'North Wales',
                        regionId: 22258,
                        url: '/wales',
                    },
                    {
                        regionName: 'Anglesey',
                        regionValue: 'Anglesey',
                        regionId: 22263,
                        url: '/wales/anglesey',
                    },
                    {
                        regionName: 'County Conwy',
                        regionValue: 'County Conwy',
                        regionId: 22286,
                        url: '/wales/county-conwy',
                    },
                    {
                        regionName: 'Gwynedd',
                        regionValue: 'Gwynedd',
                        regionId: 22269,
                        url: '/wales/gwynedd',
                    },
                    {
                        regionName: 'North Wales Borders',
                        regionValue: 'North Wales Borders',
                        regionId: 22259,
                        url: '/wales/county-conwy',
                    },
                ],
            },
        ],
        popular: {
            title: 'Popular in Wales',
            locations: [
                {
                    regionName: 'Cardigan Bay',
                    regionValue: 'Cardigan Bay',
                    regionId: 10094,
                    url: '/wales/cardigan-bay',
                },
                {
                    regionName: 'Llyn Peninsula',
                    regionValue: 'Llyn Peninsula',
                    regionId: 10095,
                    url: '/wales/llyn-peninsula',
                },
                {
                    regionName: 'Brecon Beacons',
                    regionValue: 'Brecon Beacons',
                    regionId: 9123,
                    url: '/wales/brecon-beacons',
                },
                {
                    regionName: 'Pembrokeshire Coast',
                    regionValue: 'Pembrokeshire Coast',
                    regionId: 9134,
                    url: '/wales/pembrokeshire-coast',
                },
                {
                    regionName: 'Snowdonia',
                    regionValue: 'Snowdonia',
                    regionId: 9135,
                    url: '/wales/snowdonia',
                },
            ],
        },
    },
    {
        regionName: 'Channel Islands',
        regionValue: 'Channel Islands',
        regionId: 22423,
        url: '/channel-islands',
        regions: [
            {
                regionName: 'All of Channel Islands',
                regionValue: 'Channel Islands',
                regionId: 22423,
                url: '/channel-islands',
            },
            {
                regionName: 'Jersey',
                regionValue: 'Jersey',
                regionId: 22425,
                url: '/channel-islands/jersey',
            },
        ],
    },
    {
        regionName: 'Isle of Man',
        regionValue: 'Isle of Man',
        regionId: 23663,
        url: '/isle-of-man',
        regions: [
            {
                regionName: 'All of Isle of Man',
                regionValue: 'Isle of Man',
                regionId: 23663,
                url: '/isle-of-man',
            },
        ],
    },
    boats,
];
//# sourceMappingURL=data.js.map